import React from 'react';
import { Button } from '@mui/material';
import { GridOn as CsvIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { shouldDisableExportPdfButton } from '../utils/exportPdfButton';
import { exportItemTableToCsv } from '../utils/exportToCsv';

export default function ExportCsvButton({
  exportConfig,
  disabled,
  label,
  size = 'small',
  variant = 'outlined',
  sx,
}) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (exportConfig) {
      try {
        exportItemTableToCsv(exportConfig);
      } catch (err) {
        console.error('CSV export failed', err);
      }
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      startIcon={<CsvIcon />}
      onClick={handleClick}
      disabled={shouldDisableExportPdfButton({ disabled, exportConfig })}
      sx={sx}
    >
      {label ?? t('export.csvButton')}
    </Button>
  );
}
